import { ALL_GROUPS_TABS } from '@communities/groups-layer/utils/constants'

/** First-level segments under [groupSlug] that are valid group routes (not redirect-to-home). */
export const VALID_GROUP_FIRST_SEGMENTS = new Set([
  ...Object.values(ALL_GROUPS_TABS).map(tab => tab.url?.split('/')[1]),
  'channels', // /[groupSlug]/channels/:channelSlug – not a tab
  'conversations', // /[groupSlug]/conversations – not a tab
])
